import { HtmlContent } from "@/components/Common/HtmlContent"
import { Text } from "@chakra-ui/react"

interface FlashcardContentProps {
  content: string
  color?: string
  fontWeight?: string
}

const containsHtml = (value: string) => /<[a-z][\s\S]*>/i.test(value)

export function FlashcardContent({
  content,
  color,
  fontWeight,
}: FlashcardContentProps) {
  if (!containsHtml(content)) {
    return (
      <Text color={color} fontWeight={fontWeight} whiteSpace="pre-wrap">
        {content}
      </Text>
    )
  }

  return <HtmlContent color={color} fontWeight={fontWeight} content={content} />
}
